import { useSearchParams } from 'react-router-dom';
import { FolderCard } from '~/components/FolderCard';
import type { PlaylistList__PlaylistFolder as PlaylistFolder } from '../../queries/queries.generated';
import { Menu } from './PlaylistMenu';

export interface PlaylistFolderCardProps {
  playlistFolder: PlaylistFolder;
}

export const PlaylistFolderCard = ({ playlistFolder }: PlaylistFolderCardProps) => {
  const [searchParams] = useSearchParams();
  searchParams.set('page', '1');

  return (
    <FolderCard
      folder={playlistFolder}
      to={{ pathname: `../${playlistFolder.id}`, search: searchParams.toString() }}
      label="playlist"
    >
      <Menu item={playlistFolder} />
    </FolderCard>
  );
};
